import React from "react";

const StepIntoMissionField: React.FC = () => {
  return (
    <div className="container mx-auto py-16 px-4">
      <div className="relative bg-gradient-to-br from-deepBlue to-darkBlue rounded-3xl p-8 md:p-32 lg:p-32 overflow-hidden">
        {/* Decorative circle and line */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-lightBlue bg-opacity-20 rounded-full -translate-y-1/2 translate-x-1/2">
          <div className="absolute top-1/2 left-0 w-32 h-1 bg-lightBlue bg-opacity-30 transform -rotate-45 origin-left"></div>
        </div>

        <div className="relative z-10 max-w-3xl">
          <p className="text-navYellow text-xl font-medium mb-2">
            Join our Training Team
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Step into the Mission Field
          </h2>
          <p className="text-white text-lg leading-relaxed opacity-90">
            If you have done the CBR course and would like to be involved, join our transformative team as a
            giving partner or a CBR facilitator. Contact your regional coordinator to coach you through the
            trainer's course and learn more about facilitating opportunities in your region.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepIntoMissionField;

